<template>
	<div class="container">
		<div class="user-levels">
			<b-alert show>Users level sets</b-alert>

			<div class="overflow-auto" v-if="total > 0">
				<b-pagination-nav
					@change="setPage"
					:link-gen="linkGen"
					:number-of-pages="totalPages"
					use-router
					limit="12"
					align="center"
				></b-pagination-nav>
			</div>

			<router-link
				:to="{ path: '/play-levelset/' + lvlSet.id + '/' + slug(lvlSet.name) }"
				v-for="lvlSet in levelsets"
				:key="lvlSet.id"
			>
				<span
					style="display: inline-block; font-size: 0.8em;"
					class="text-left"
				>
					<!-- <b-icon icon="eye" v-if="lvlSet.active"></b-icon> {{ lvlSet.showed_times }}  -->
					<span v-if="calcScore(lvlSet) > 0">
						<b-icon icon="hand-thumbs-up"></b-icon>
						{{ calcScore(lvlSet) }}
					</span>
					<br />

					<level-view
						:levelData="lvlSet.leveldata"
						:tileWidth="12"
						:levelName="lvlSet.name+' by '+lvlSet.user_name"
					></level-view>
				</span>
			</router-link>

			<div class="overflow-auto" v-if="total > 0">
				<b-pagination-nav
					@change="setPage"
					:link-gen="linkGen"
					:number-of-pages="totalPages"
					use-router
					limit="12"
					align="center"
				></b-pagination-nav>
			</div>
		</div>
	</div>
</template>

<style lang="scss"></style>

<script>
import LevelView from '../components/LevelView.vue';
import slugify from 'slugify';

export default {
	name: 'UserLevels',
	mounted: async function() {
		await this.setTotal();
		let page = this.$route.query.page || 1;
		await this.loadPage(page);
	},
	components: {
		LevelView
	},
	data: function() {
		return {
			total: 0,
			page: 1,
			levelsets: []
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.total / 15);
		}
	},
	methods: {
		calcScore(lvl) {
			if (lvl.score_count == 0) return 0;
			return Math.round(lvl.score_count / lvl.score);
		},
		slug(name) {
			return slugify(name);
		},
		setPage(page) {
			console.log('setPage', page);
			if (Number.isNaN(+page)) {
				page = 1;
			}
			this.page = +page;
			return this.loadPage(page);
		},
		linkGen(pageNum) {
			// console.log('linkGen', pageNum);
			// return pageNum === 1 ? '?' : `?page=${pageNum}`
			return {
				query: {
					page: pageNum
				}
			};
		},
		loadPage(page) {
			return fetch(`/api/v1/levelset?page=${page}&size=15`)
				.then(data => data.json())
				.then(data => (this.levelsets = data.lvlData));
		},
		setTotal() {
			return fetch('/api/v1/levelset/total')
				.then(data => data.json())
				.then(data => {
					this.total = data.total;
				});
		}
	}
};
</script>
